<template lang="html">
  <div class="content">
    
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'backendAudit',
  data() {
    return {
      
    }
  },
  methods: {
    
  },
  mounted() {
    this.$adminauditProcess({
      title: this.$route.query.title,
      id: this.$route.query.id,
      platform_key: this.$route.query.platform_key,
      column_key: this.$route.query.column_key,
      type: this.$route.query.type || 'normal'
    }).then(res => {
      if(res){
        if(this.$route.query.backurl){
          window.location.href=decodeURIComponent(this.$route.query.backurl)
        }else{
          window.close()
        }
      }else{
        window.close()
      }
    })
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

</style>
